export function getCookie(name: string) {
  const v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
  return v ? v[2] : null;
}

export function setCookie(name: string, value: string, days: number = 182, subdomainWhitelist: boolean = false) {
  const d = new Date();
  d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);

  const currentHost = window.location.hostname;
  const domain = subdomainWhitelist ? 'domain=' + currentHost.slice(currentHost.indexOf('.')) : '';
  const cookie = `${name}=${value};secure;SameSite=Strict;path=/;expires=${d.toUTCString()};${domain}`;
  document.cookie = cookie;
}
